export const LOG_HISTORY_SET_PAGINATION = "LOG_HISTORY_SET_PAGINATION";
export const LOG_HISTORY_SET_FILTERS = "LOG_HISTORY_SET_FILTERS";
export const LOG_HISTORY_RESET_FILTERS = "LOG_HISTORY_RESET_FILTERS";
export const LOG_HISTORY_SET_SORTING = "LOG_HISTORY_SET_SORTING";
export const EVENT_LOG_HISTORY_FILTER_SUBMIT =
  "EVENT_LOG_HISTORY_FILTER_SUBMIT";
